export const color0 = "#2E3440";
export const color1 = "#3B4252";
export const color2 = "#434C5E";
export const color3 = "#4C566A";
export const color4 = "#D8DEE9";
export const color5 = "#E5E9F0";
export const color6 = "#ECEFF4";
export const color7 = "#8FBCBB";
export const color8 = "#88C0D0";
export const color9 = "#81A1C1";
export const color10 = "#5E81AC";
export const color11 = "#BF616A";
export const color12 = "#D08770";
export const color13 = "#EBCB8B";
export const color14 = "#A3BE8C";
export const color15 = "#B48EAD";

export const fontName = "Saira Condensed";

export const backgroundColor = color0;
export const primaryFontColor = color6;
export const secondaryFontColor = color5;
export const IconHoverColor = color7;
